<template>
  <div :id="`videoPlayerVss-${playlistId.split(':').join('-')}`" class="mc-videoplayer-vss"></div>
</template>

<script>
export default {
  name: 'ViideoStreamVss',
  props: {
    playlistId: {
      type: String,
      required: true,
    },
    controls: {
      type: Boolean,
      default: false,
    },
    imei: {
      type: String,
      required: true,
    },
    channel: {
      type: Number,
      required: true,
    },
    type: {
      type: String, // 'live' | 'playback'
      required: true,
    },
    startTime: {
      type: String,
      required: false,
      default: null,
    },
    endTime: {
      type: String,
      required: false,
      default: null,
    },
    defaultOpenAudio: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      wsUrl: process.env.VUE_APP_VSS_WS_URL,
      port: process.env.VUE_APP_VSS_PORT,

      playerVss: null,

      // for playback
      intervalCheckTimePlayback: null,
      currentTime: null,
    }
  },
  async mounted() {
    this.initPlayer()
    await this.$nextTick()
    if (this.type === 'live') {
      this.startLive()
    } else if (this.type === 'playback') {
      this.startPlayback()
    }
    console.log("URL -", this.wsUrl, this.port)
  },
  beforeDestroy() {
    this.playerVss.stop()
    clearInterval(this.intervalCheckTimePlayback)
  },
  methods: {
    initPlayer() {
      // eslint-disable-next-line no-undef
      this.playerVss = new VssPlayer(
        `#videoPlayerVss-${this.playlistId.split(':').join('-')}`,
        (status) => {
          console.log(status.status)
        },
        this.type
      )
    },
    startLive() {
      const url = this.wsUrl
      const port = this.port
      const deviceId = this.imei
      const channel = this.channel
      const stream = '0'
      const openAudio = this.defaultOpenAudio
      const bufferTimeMs = '0'
      const username = this.$store.state.identity.whoami?.email
      const ipaddr = '127.0.0.1'

      this.playerVss.live(
        url,
        port,
        deviceId,
        channel,
        stream,
        openAudio,
        bufferTimeMs,
        username,
        ipaddr
      )
      this.playerVss.openAudio(this.defaultOpenAudio)
      this.$emit('ready')
    },
    startPlayback() {
      const url = this.wsUrl
      const port = this.port
      const deviceId = this.imei
      const channel = this.channel
      const start = this.startTime
      const end = this.endTime
      const username = this.$store.state.identity.whoami?.email
      const openAudio = this.defaultOpenAudio
      const ipaddr = '127.0.0.1'

      this.playerVss.playback(url, port, deviceId, channel, start, end, openAudio, username, ipaddr)
      this.playerVss.openAudio(this.defaultOpenAudio)
      this.playerVss.playbackSpeed(1)

      const diffSeconds = this.getDiffsSecondPlayback(this.startTime, this.endTime)

      this.intervalCheckTimePlayback = setInterval(async () => {
        const tolerance = 3
        const prevCurrentTime = this.currentTime
        this.currentTime = this.playerVss.currentTime
        await this.$nextTick()
        if (this.currentTime >= diffSeconds - tolerance && prevCurrentTime === this.currentTime) {
          clearInterval(this.intervalCheckTimePlayback)
          this.$emit('playbackEnd')
        }
      }, 1000)
    },
    setOpenAudio(openAudio) {
      this.playerVss.openAudio(openAudio)
    },
    pausePlayback() {
      this.playerVss.pause()
    },
    resumePlayback() {
      this.playerVss.resumePlay()
    },

    getDiffsSecondPlayback(startTimeStr, endTimeStr) {
      // Convert strings to Date objects
      const startTime = new Date(startTimeStr)
      const endTime = new Date(endTimeStr)

      // Calculate difference in milliseconds
      const diffMs = endTime - startTime

      // Convert milliseconds to seconds
      const diffSeconds = diffMs / 1000
      return diffSeconds
    },
  },
}
</script>
